var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-row",
        { staticClass: "baseInfo", attrs: { gutter: 14 } },
        [
          _c(
            "el-col",
            _vm._b({ staticClass: "ivu-mb" }, "el-col", _vm.grid, false),
            [
              _c(
                "el-card",
                {
                  attrs: {
                    bordered: false,
                    "dis-hover": "",
                    padding: 12,
                    shadow: "never",
                  },
                },
                [
                  _c(
                    "el-collapse",
                    {
                      model: {
                        value: _vm.activeCPU,
                        callback: function ($$v) {
                          _vm.activeCPU = $$v
                        },
                        expression: "activeCPU",
                      },
                    },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "CPU信息", name: "1" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: _vm.cpuInfo },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { prop: "name", label: "属性" },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "value", label: "值" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            _vm._b({ staticClass: "ivu-mb" }, "el-col", _vm.grid, false),
            [
              _c(
                "el-card",
                {
                  attrs: {
                    bordered: false,
                    "dis-hover": "",
                    padding: 12,
                    shadow: "never",
                  },
                },
                [
                  _c(
                    "el-collapse",
                    {
                      model: {
                        value: _vm.activeMemory,
                        callback: function ($$v) {
                          _vm.activeMemory = $$v
                        },
                        expression: "activeMemory",
                      },
                    },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "内存信息", name: "1" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: _vm.memoryInfo },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { prop: "name", label: "属性" },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "value", label: "内存" },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "JVM", label: "JVM" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "mt14" },
            [
              _c(
                "el-card",
                {
                  attrs: {
                    bordered: false,
                    "dis-hover": "",
                    padding: 12,
                    shadow: "never",
                  },
                },
                [
                  _c(
                    "el-collapse",
                    {
                      model: {
                        value: _vm.activeServer,
                        callback: function ($$v) {
                          _vm.activeServer = $$v
                        },
                        expression: "activeServer",
                      },
                    },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "服务器信息", name: "1" } },
                        [
                          _c(
                            "el-descriptions",
                            {
                              staticClass: "margin-top",
                              attrs: { column: 2, border: "" },
                            },
                            [
                              _c(
                                "el-descriptions-item",
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v(" 服务器名称 "),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.serverInfo.serverName) +
                                      " "
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "el-descriptions-item",
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v(" 操作系统 "),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.serverInfo.operatingSystem) +
                                      " "
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "el-descriptions-item",
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v(" 服务器IP "),
                                  ]),
                                  _vm._v(
                                    " " + _vm._s(_vm.serverInfo.serverIp) + " "
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "el-descriptions-item",
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v(" 系统架构 "),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.serverInfo.systemArchitecture
                                      ) +
                                      " "
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "mt14" },
            [
              _c(
                "el-card",
                {
                  attrs: {
                    bordered: false,
                    "dis-hover": "",
                    padding: 12,
                    shadow: "never",
                  },
                },
                [
                  _c(
                    "el-collapse",
                    {
                      model: {
                        value: _vm.activeJvm,
                        callback: function ($$v) {
                          _vm.activeJvm = $$v
                        },
                        expression: "activeJvm",
                      },
                    },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "Java虚拟机信息", name: "1" } },
                        [
                          _c(
                            "el-descriptions",
                            {
                              staticClass: "margin-top",
                              attrs: { column: 2, border: "" },
                            },
                            [
                              _c(
                                "el-descriptions-item",
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v(" Java名称 "),
                                  ]),
                                  _vm._v(
                                    " " + _vm._s(_vm.jvmInfo.javaName) + " "
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "el-descriptions-item",
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v(" Java版本 "),
                                  ]),
                                  _vm._v(
                                    " " + _vm._s(_vm.jvmInfo.javaVersion) + " "
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "el-descriptions-item",
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v(" 启动时间 "),
                                  ]),
                                  _vm._v(
                                    " " + _vm._s(_vm.jvmInfo.startTime) + " "
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "el-descriptions-item",
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v(" 运行时长 "),
                                  ]),
                                  _vm._v(
                                    " " + _vm._s(_vm.jvmInfo.runningTime) + " "
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "el-descriptions-item",
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v(" 安装路径 "),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.jvmInfo.installationPath) +
                                      " "
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "el-descriptions-item",
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v(" 项目路径 "),
                                  ]),
                                  _vm._v(
                                    " " + _vm._s(_vm.jvmInfo.projectPath) + " "
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "el-descriptions-item",
                                [
                                  _c("template", { slot: "label" }, [
                                    _vm._v(" 运行参数 "),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.jvmInfo.operatingParameters) +
                                      " "
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "mt14" },
            [
              _c(
                "el-card",
                {
                  attrs: {
                    bordered: false,
                    "dis-hover": "",
                    padding: 12,
                    shadow: "never",
                  },
                },
                [
                  _c(
                    "el-collapse",
                    {
                      model: {
                        value: _vm.activeDiskInfo,
                        callback: function ($$v) {
                          _vm.activeDiskInfo = $$v
                        },
                        expression: "activeDiskInfo",
                      },
                    },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "磁盘状态", name: "1" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: _vm.diskInfoList },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "driveLetterPath",
                                  label: "盘符路径",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "fileSystem",
                                  label: "文件系统",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "driveLetterType",
                                  label: "盘符类型",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "totalSize", label: "总大小" },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "usableSize",
                                  label: "可用大小",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "usedSize", label: "已用大小" },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "usedRate",
                                  label: "已用百分比",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }